import React, { Component, Suspense } from "react";
import { config } from "../../config";
import axios from "axios";
import LoadingOverlay from "../../component/LoadingOverlay";
import localforage from "localforage"; // ✅ Tambahkan library cache
import { fetchSharedData } from "../../utils/sharedFetcher";
import LazySection from "../../component/LazySection/LazySection";

// Importing Section
const Navbar = React.lazy(() => import("../../component/Navbar/NavBar"));
const Carousel = React.lazy(() => import("../../component/Carousel"));
const VisiMisi = React.lazy(() => import("../../component/VisiMisi"));
const Footer = React.lazy(() => import("../../component/Footer/Footer"));
const Artikel = React.lazy(() => import("../../component/Artikel"));
const DesaKami = React.lazy(() => import("../../component/DesaKami"));
const PetaDesa = React.lazy(() => import("../../component/PetaDesa"));
const AparaturDesa = React.lazy(() => import("../../component/AparaturDesa"));
const Galeri = React.lazy(() => import("../../component/Galeri"));
const Fasilitas = React.lazy(() => import("../../component/Fasilitas"));
const Layanan = React.lazy(() => import("../../component/Layanan"));
const Struktur = React.lazy(() => import("../../component/Struktur"));
const Komoditas = React.lazy(() => import("../../component/Komoditas"));
const DesaCantik = React.lazy(() => import("../DesaCantik/DesaCantik"));
const Infografik = React.lazy(() => import("../Infografik/Infografik"));
const Publikasi = React.lazy(() => import("../Publikasi/Publikasi"));

class Layout1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDesaCantikOnly: false,
      userIp: "",
      userLocation: {},
      loading: true,
      error: null,
      navItems: [
        { id: 1, idnm: "beranda", navheading: "Beranda" },
        { id: 3, idnm: "visi-misi", navheading: "Visi Misi" },
        { id: 6, idnm: "article", navheading: "Artikel" },
        { id: 7, idnm: "DesaKami", navheading: "Desa Kami" },
        { id: 8, idnm: "PetaDesa", navheading: "Peta" },
        { id: 10, idnm: "galery", navheading: "Galeri" },
        { id: 11, idnm: "struktur", navheading: "Struktur" },
        { id: 12, idnm: "aparatur-desa", navheading: "Aparatur Desa" },
        { id: 13, idnm: "fasilitas", navheading: "Fasilitas" },
        { id: 15, idnm: "komoditas", navheading: "Komoditas" },
        { id: 16, idnm: "layanan", navheading: "Layanan Desa" },
        { id: 17, idnm: "desacantik", navheading: "Desa Cantik" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
      carouselItems: [],
      dataDusun: [],
      aparaturData: [],
      articles: [],
      fasilitas: [],
      komoditas: [],
      kegiatan: [],
      layanan: [],
      footerData: {},
      videoUrl: "",
      petaUrl: "",
      strukturDesa: "",
      nama: "",
      visi: "",
      misi: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
    this.fetchData();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  changeFavicon = (faviconUrl) => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  };

  // ✅ Helper untuk membuat cache key
  getCacheKey = () => {
    const domain = window.location.hostname;
    return `webdesa_data_${domain}`;
  };

  fetchData = async () => {
    this.setState({ loading: true });
    const namaDomain = window.location.href;
    const cacheKey = this.getCacheKey();

    try {
      // ✅ 1. Cek cache dulu
      const cached = await localforage.getItem(cacheKey);
      const now = Date.now();
      const cacheTTL = 24 * 60 * 60 * 1000; // 24 jam

      if (cached && now - cached.timestamp < cacheTTL) {
        // ✅ Gunakan data cache langsung
        this.setState({ ...cached.data, loading: false });
        
        // Update Favicon dan Title dari cache
        if (cached.data.footerData?.logo) {
          this.changeFavicon(cached.data.footerData.logo);
        }
        if (cached.data.nama) {
          document.title = cached.data.nama;
        }
        return;
      }

      // ✅ 2. Kalau tidak ada cache → fetch data dari API
      const response = await fetchSharedData(
        `${config.BASE_URL}organization/findContentOrganization?namaDomain=${namaDomain}`
      );

      if (!response.data.status) {
        this.setState({ loading: false, error: "Failed to load data" });
        return;
      }

      const {
        berita,
        organization,
        dusun,
        carousel,
        jumahLakiLaki,
        jumahPerempuan,
        aparaturOrganizations,
        struktural,
        fasilitas,
        komoditas,
        kegiatan,
        layanan,
      } = response.data.data;

      // ✅ Transformasi data sama seperti sebelumnya
      const articles = (berita || []).map((item) => ({
        beritaId: item.beritaId,
        judul: item.judul || "Untitled Article",
        isi: item.isi || "-",
        created: item.tanggalRelease || item.created,
        foto: item.foto
          ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
              item.foto
            )}`
          : "",
      }));

      const aparaturData = (aparaturOrganizations || []).map((item) => ({
        img: item.foto
          ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
              item.foto
            )}`
          : "",
        nama: item.nama,
        jabatan: item.jabatan,
        quotes: item.quotes,
      }));

      const transformedKomoditas = (komoditas || []).map((item, index) => ({
        komoditasId: item.komoditasId || index,
        created: item.created || "",
        nama: item.nama || "Unknown Name",
        keterangan: item.keterangan || "No Description",
        foto: item.foto
          ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
              item.foto
            )}`
          : "",
      }));

      let strukturDesa = "";
      if (Array.isArray(struktural) && struktural[0]?.foto) {
        strukturDesa = `${
          config.BASE_URL
        }getReferenceFile?pathFile=${encodeURIComponent(struktural[0].foto)}`;
      }

      const formattedFasilitas = (fasilitas || []).map((item) => ({
        ...item,
        foto: (item.fasilitasDetail || []).map((d) =>
          d.foto
            ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
                d.foto
              )}`
            : ""
        ),
      }));

      const formattedKegiatan = (kegiatan || []).map((item) => ({
        ...item,
        foto: (item.kegiatanDetail || []).map((d) =>
          d.foto
            ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
                d.foto
              )}`
            : ""
        ),
      }));

      const formattedLayanan = (layanan || []).map((item) => ({
        nama: item.nama || "",
        keterangan: item.keterangan || "Deskripsi tidak tersedia",
        created: item.created,
        createdBy: item.createdBy,
        layananId: item.layananId,
      }));

      const footerData = {
        alamat: organization.alamat || "",
        contactNumber: organization.contactNumber || "",
        email: organization.email || "",
        logo: organization.logo
          ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
              organization.logo
            )}`
          : "",
      };

      const transformedData = {
        nama: organization.nama,
        visi: organization.visi,
        misi: organization.misi,
        videoUrl: organization.urlVideo
          ? `https://www.youtube.com/embed/${organization.urlVideo}?autoplay=1`
          : "",
        petaUrl: organization.peta,
        articles,
        footerData,
        dataDusun: (dusun || []).map((item, index) => ({
          nama: item.nama || `Dusun ${index + 1}`,
          jumlah: item.jumlahWarga || "-",
          created: item.created,
          createdBy: item.createdBy,
          mdusunId: item.mdusunId,
        })),
        carouselItems: (carousel || []).map((item) => ({
          carouselId: item.carouselId,
          deskripsi: item.deskripsi,
          image: item.image
            ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
                item.image.trim()
              )}`
            : "",
          backgroundImage: item.backgroundImage
            ? `${config.BASE_URL}getReferenceFile?pathFile=${item.backgroundImage}`
            : "",
          width: item.width,
          height: item.height,
          positionVertical: item.positionVertical,
          positionHorizontal: item.positionHorizontal,
        })),
        aparaturData,
        strukturDesa,
        fasilitas: formattedFasilitas,
        komoditas: transformedKomoditas,
        kegiatan: formattedKegiatan,
        layanan: formattedLayanan,
      };

      // ✅ 3. Simpan hasil fetch ke cache
      await localforage.setItem(cacheKey, {
        timestamp: now,
        data: transformedData,
      });

      // ✅ 4. Set state dari data baru
      this.setState({ ...transformedData, loading: false });

      // Update Favicon dan Title dari API
      if (footerData.logo) {
        this.changeFavicon(footerData.logo);
      }
      if (organization.nama) {
        document.title = organization.nama;
      }
    } catch (error) {
      console.error("Fetch error:", error);
      this.setState({ loading: false, error: "Failed to load data" });
    }
  };

  scrollNavigation = () => {
    const scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  handleSelectSection = (sectionId) => {
    if (sectionId === "desacantik") {
      this.setState({ showDesaCantikOnly: true });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      this.setState({ showDesaCantikOnly: false });
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  render() {
    return (
      <Suspense fallback={<LoadingOverlay />}>
        <Navbar
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
          onSelectSection={this.handleSelectSection}
          setDesaCantikActive={(value) =>
            this.setState({ showDesaCantikOnly: value })
          }
        />
        {this.state.showDesaCantikOnly ? (
          <DesaCantik data={this.state.desaCantikData} />
        ) : (
          <>
            <Carousel carouselItems={this.state.carouselItems} />
            <VisiMisi visi={this.state.visi} misi={this.state.misi} />
            <Artikel articles={this.state.articles} />
            <DesaKami videoUrl={this.state.videoUrl} />
            <LazySection id="PetaDesa" rootMargin="200px" minHeight="400px">
              <PetaDesa petaUrl={this.state.petaUrl} />
            </LazySection>
            <LazySection id="galery" rootMargin="200px" minHeight="500px">
              <Galeri kegiatan={this.state.kegiatan} />
            </LazySection>
            <LazySection id="struktur" rootMargin="200px" minHeight="400px">
              <Struktur strukturDesa={this.state.strukturDesa} />
            </LazySection>
            <LazySection id="aparatur-desa" rootMargin="200px" minHeight="400px">
              <AparaturDesa aparaturData={this.state.aparaturData} />
            </LazySection>
            <LazySection id="fasilitas" rootMargin="200px" minHeight="500px">
              <Fasilitas fasilitas={this.state.fasilitas} />
            </LazySection>
            <LazySection id="komoditas" rootMargin="200px" minHeight="400px">
              <Komoditas komoditas={this.state.komoditas} />
            </LazySection>
            <LazySection id="layanan" rootMargin="200px" minHeight="400px">
              <Layanan layanan={this.state.layanan} />
            </LazySection>
            <Footer footerData={this.state.footerData} />
          </>
        )}
      </Suspense>
    );
  }
}

export default Layout1;
